import React from "react";
import ScoreCard from "../ScoreCard/ScoreCard";
import Skeleton from "react-loading-skeleton";

export interface StatisticsCardProps {
  imageSource: string;
  id: number;
  name: string;
  totalQuize: number;
  correct: number;
  error: number;
  noAnswer: number;
  onResetPress: () => void;
  containerClassName?: string;
}

const StatisticsCard: React.FC<StatisticsCardProps> = ({
  imageSource,
  id,
  name,
  totalQuize,
  correct,
  error,
  noAnswer,
  onResetPress,
  containerClassName,
}) => {
  return (
    <div className={`statistics-card ${containerClassName || ""}`}>
      <button className="reset-button" onClick={onResetPress}>
        Reset
      </button>

      <div className="card-header">
        <img src={imageSource} alt={name} className="card-image" />
        <div className="card-info">
          <span className="card-id">Capitolo {id}</span>
          <h3 className="card-title">{name}</h3>
        </div>
      </div>

      <div className="score-cards-container">
        <ScoreCard
          score={totalQuize}
          title="Total quiz"
          color="#000000"
          backgroundColor="rgba(0, 0, 0, 0.1)"
        />
        <ScoreCard
          score={correct}
          title="Risposte corrette"
          color="#7cb940"
          backgroundColor="rgba(124, 185, 64, 0.1)"
        />
        <ScoreCard
          score={error}
          title="Errori da ripassare"
          color="#e22f38"
          backgroundColor="rgba(226, 47, 56, 0.1)"
        />
        <ScoreCard
          score={noAnswer}
          title="Risposte non date"
          color="#ffb445"
          backgroundColor="rgba(255, 180, 69, 0.1)"
        />
      </div>
    </div>
  );
};

export const StatisticsCardSkeleton: React.FC = () => {
  return (
    <div className="statistics-card">
      <div className="reset-button-skeleton">
        <Skeleton width={60} height={25} />
      </div>

      <div className="card-header">
        <Skeleton height={100} width={100} />
        <div className="card-info">
          <Skeleton width={100} height={16} style={{ marginBottom: 4 }} />
          <Skeleton width={200} height={20} />
        </div>
      </div>

      <div className="score-cards-container">
        <div className="skeleton-score-card">
          <Skeleton width={60} height={20} />
          <Skeleton width={50} height={14} />
        </div>
        <div className="skeleton-score-card">
          <Skeleton width={60} height={20} />
          <Skeleton width={50} height={14} />
        </div>
        <div className="skeleton-score-card">
          <Skeleton width={60} height={20} />
          <Skeleton width={50} height={14} />
        </div>
        <div className="skeleton-score-card">
          <Skeleton width={60} height={20} />
          <Skeleton width={50} height={14} />
        </div>
      </div>
    </div>
  );
};

export default StatisticsCard;
